import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Box } from '@wix/design-system';
import { Widget } from '../widget/widget';
import { useFieldAttributes } from '../../services/field-attributes';
import { FieldDescriptionWUT } from '../field-description/field-description-wut';
import { SignatureView } from './signature-types';
import { SignatureHeaderWUT } from './signature-header/signature-header-wut';
import { FieldLabelWUT } from '../field-label/field-label-wut';
import { FieldErrorWUT } from '../field-error/field-error-wut';
import { SignatureDrawerWUT } from './signature-drawer/signature-drawer-wut';
import { SignatureTextWUT } from './signature-text/signature-text-wut';
import { SignatureImageWUT } from './signature-image/signature-image-wut';
import { SignatureUploadWUT } from './signature-upload/signature-upload-wut';
import { useSignatureField } from './use-signature-field';
import styles from './signature-field-wut.module.scss';
export const SignatureFieldWUT = props => {
  const {
    id,
    required,
    label,
    hideLabel = false,
    target,
    description,
    validation,
    error,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    onBlur,
    onFocus,
    uploadEnabled,
    FieldLayout,
    onChange,
    value,
    readOnly,
    hasError = false,
    errorMessage,
    widgetHtml,
    widgetEnabled,
    ...rest
  } = props;
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  const {
    signatureMode,
    clearable,
    signatureValueForView,
    signatureView,
    handleChange,
    setSignatureMode,
    handleBeforeChange,
    handleClear
  } = useSignatureField({
    target,
    value,
    onChange
  });
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      width: "100%"
    }, /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      htmlFor: inputId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement
    }), !readOnly && /*#__PURE__*/React.createElement(SignatureHeaderWUT, {
      signatureMode: signatureMode,
      onModeChange: setSignatureMode,
      onClear: handleClear,
      clearable: clearable,
      uploadEnabled: uploadEnabled,
      inputId: inputId,
      ariaLabelledBy: labelId,
      target: target
    })),
    renderInput: () => widgetHtml && widgetEnabled ? /*#__PURE__*/React.createElement(Widget, {
      fieldId: id,
      widgetHtml: widgetHtml,
      onChange: onChange,
      value: value
    }) : /*#__PURE__*/React.createElement("div", {
      "data-hook": "signature-input",
      className: styles.signatureField
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.inputContainer
    }, signatureView === SignatureView.DRAW && /*#__PURE__*/React.createElement(SignatureDrawerWUT, _extends({
      fieldId: id,
      inputId: inputId,
      hasError: hasError,
      onChange: handleChange,
      value: signatureValueForView,
      onBlur: onBlur,
      required: required,
      readOnly: readOnly,
      onBeforeChange: handleBeforeChange,
      ariaLabelledBy: labelId,
      ariaDescribedBy: ariaDescribedBy
    }, rest)), signatureView === SignatureView.TYPE && /*#__PURE__*/React.createElement(SignatureTextWUT, {
      fieldId: id,
      inputId: inputId,
      hasError: hasError,
      onChange: handleChange,
      value: signatureValueForView,
      onBlur: onBlur,
      required: required,
      onBeforeChange: handleBeforeChange,
      readOnly: readOnly,
      ariaLabel: label,
      ariaDescribedBy: ariaDescribedBy
    }), signatureView === SignatureView.IMAGE && /*#__PURE__*/React.createElement(SignatureImageWUT, {
      id: inputId,
      value: signatureValueForView
    }), signatureView === SignatureView.UPLOAD && /*#__PURE__*/React.createElement(SignatureUploadWUT, {
      id: inputId,
      onBlur: onBlur,
      readOnly: readOnly,
      required: required,
      handleChange: handleChange,
      hasError: hasError,
      ariaLabelledBy: labelId,
      ariaDescribedBy: ariaDescribedBy
    }))),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      id: errorId,
      target: target,
      hasError: hasError,
      errorMessage: errorMessage
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }))
  });
};
//# sourceMappingURL=signature-field-wut.js.map